.stepper {
  display: flex;
  align-items: flex-start;
  gap: var(--mantine-spacing-xs);
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  gap: var(--mantine-spacing-xs);
}

.dot {
  width: 16px;
  height: 16px;
  border-radius: var(--mantine-radius-xl);
  border: 2px solid var(--adl-border-light);
  background: var(--adl-surface-container);
}

.dotCompleted {
  border-color: var(--adl-status-inform-medium);
  background: var(--adl-status-inform-medium);
}

.dotActive {
  border-color: var(--adl-status-inform-medium);
  background: var(--adl-status-inform-medium);
}

.stepLabel {
  font-size: var(--mantine-font-size-xs);
  color: var(--adl-text-secondary);
  text-align: center;
}

.stepLabelActive {
  color: var(--adl-status-inform-medium);
  font-weight: 600;
}

.stepLabelCompleted {
  color: var(--adl-text-primary);
}

.connector {
  flex: 1;
  height: 2px;
  margin-top: 7px;
  background: var(--adl-border-light);
}

.connectorCompleted {
  background: var(--adl-status-inform-medium);
}

.proRow {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-xs);
  margin-top: var(--mantine-spacing-md);
}

.proLabel {
  font-size: var(--mantine-font-size-xs);
  font-weight: 600;
  color: var(--adl-text-secondary);
}

.proLink {
  display: inline-flex;
  align-items: center;
  gap: var(--mantine-spacing-xs);
}

.updates {
  margin-top: var(--mantine-spacing-md);
}

.event {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-xs);
}

.eventStatus {
  font-size: var(--mantine-font-size-sm);
  font-weight: 600;
  color: var(--adl-text-primary);
}

.eventMeta {
  font-size: var(--mantine-font-size-xs);
  color: var(--adl-text-secondary);
}

.lastUpdated {
  font-size: var(--mantine-font-size-xs);
  color: var(--adl-text-secondary);
  margin-top: var(--mantine-spacing-sm);
}
